import Reveal from "@/components/Reveal";

const PHASES = [
  {
    tag: "01",
    title: "Clinical Development",
    desc: "Patient burden, unmet need, quality-of-life priorities, and PRO / endpoint relevance.",
  },
  {
    tag: "02",
    title: "Launch Readiness",
    desc: "Patient-centered evidence for medical strategy, education, positioning, and launch planning.",
  },
  {
    tag: "03",
    title: "Regulatory & Evidence Planning",
    desc: "Patient experience insights that support evidence planning and patient-focused strategy discussions.",
  },
  {
    tag: "04",
    title: "HTA & Market Access",
    desc: "Patient-relevant burden, quality-of-life, caregiver, access, and value narrative inputs.",
  },
  {
    tag: "05",
    title: "Post-Launch Growth",
    desc: "Treatment experience, sentiment evolution, adherence, switching, education gaps, and lifecycle opportunities.",
  },
];

export default function LifecycleSection() {
  return (
    <section className="bg-ink-1 relative" data-testid="lifecycle-section">
      <div className="container-edge py-24 lg:py-32">
        <Reveal>
          <div className="eyebrow">The lifecycle view</div>
          <h2 className="font-serif font-normal text-3xl md:text-5xl lg:text-[3.5rem] tracking-tight mt-4 text-parchment-bright max-w-3xl leading-[1.05]">
            Five stages. One patient-evidence method.
          </h2>
        </Reveal>

        <div className="mt-16 relative">
          <div className="absolute top-7 left-0 right-0 h-px bg-white/[0.08] hidden md:block" />
          <div className="grid grid-cols-1 md:grid-cols-5 gap-4 md:gap-5">
            {PHASES.map((p, i) => (
              <Reveal
                key={p.tag}
                delay={i * 90}
                className="relative flex flex-col"
                data-testid={`lifecycle-phase-${p.tag}`}
              >
                <div className="hidden md:flex items-center gap-3">
                  <span className="w-3 h-3 border border-rust bg-ink-1 z-10 relative" />
                  <span className="font-mono text-[10px] uppercase tracking-[0.22em] text-rust">
                    {p.tag}
                  </span>
                </div>
                <div className="md:hidden font-mono text-[10px] uppercase tracking-[0.22em] text-rust mb-2">
                  {p.tag}
                </div>
                <div className="mt-5 card-dark p-6 flex flex-col flex-1 h-full min-h-[260px]">
                  <h3 className="font-serif text-[1.55rem] text-parchment-bright leading-tight min-h-[3.5rem]">
                    {p.title}
                  </h3>
                  <p className="mt-5 text-[13.5px] text-parchment/75 leading-relaxed flex-1">
                    {p.desc}
                  </p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
